import React from 'react';
import AboutPage from '../components/AboutPage';

const About = () => {
  return <AboutPage lang="ptbr" title="Sobre o Curso | Full Stack Aberto" />;
};

export default About;
